<form class="form-container" [formGroup]="mfaForm" (ngSubmit)="confirmMFACode()">
    <h1 class="serif-title" *ngIf="title">{{title}}</h1>
    <h3>
        <div class="text">{{text}}</div>
    </h3>
    <app-notification-bubble></app-notification-bubble>
    <section class="content-container">
        <section class="sign-get-info">
                <section class="form-group">
                    <div class="mfa-msg-container">
                        <input type="tel" class="form-control code-auth" id="mfaCode" placeholder="Enter code" required
                            formControlName="mfaCode" />

                        <div class="error-message-mfa" *ngIf="errorMessageMfaNotReceiving || errorMessageMfaNotTrue">
                            <ng-container *ngIf="errorMessageMfaNotReceiving">Still not receiving the code? We sent it
                                to {{phoneNumber}}.</ng-container> <br>
                            <!-- <ng-container *ngIf="errorMessageMfaNotReceiving || errorMessageMfaNotTrue">
                                To update your mobile number <span class="click-here"
                                    (click)="switchStatus('updateMobile')">click here</span>. <br>
                                To switch to email authentication instead <span class="click-here"
                                    (click)="switchStatus('nosend')">click here</span>.
                            </ng-container> -->
                        </div>
                    </div>

                    <div *ngIf="MFAEmpty == true" class="invalid-feedback">
                        <div>Multi-Factor authentication code is required to continue.</div>
                    </div>
                    <div *ngIf="MFAFail == true" class="invalid-feedback">
                        <div>Invalid Multi-Factor authentication code.</div>
                    </div>
                </section>
            <section class="form-group forgot-info resend-code">
                <input (click)="resendMFA()" [disabled]="resendCodeDisabled" value="Resend code" [ngClass]="{'disabled-btn': resendCodeDisabled}">
                <div class="counter" *ngIf="resendCodeDisabled">
                    You can resend a new one in {{ counter }} seconds.
                </div>
            </section>
            <section class="submit-info">
                <input type="submit" class="form-control btn btn-primary primary-default-btn confirm-btn"
                    value="{{textBtn}}" [ngClass]="{'nwr-theme-input': themeService.theme == 'NWRTheme'}"/>
            </section>
        </section>

    </section>
</form>